<!--
 * @description: 顶部背景
 * @Author: Jay
 * @Date: 2021-09-24 11:06:38
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 15:38:18
-->
<template>
  <div>
    <div class="bg-code" :style="[{ backgroundImage: 'url(' + bgImg + ')' }]">
      <div class="code-title text-align">
        <!-- <div v-class="'animate__animated animate__fadeInUp'">
          <div class="font_size_xl text-white">{{ title }}</div>
          <div class="font_size_df margin-top-sm text-white">{{ EnTitle }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bgImgTop",
  props: {
    title: {
      type: String,
      require: true,
    },
    EnTitle: {
      type: String,
      require: true,
    },
    bgImg: {
      type: String,
      require: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.bg-code {
  width: 100vw;
  height: 595px;
  position: relative;
  background-repeat: no-repeat 50%;
  background-size: cover;
}

.code-title {
  position: absolute;
  top: 30%;
  left: 44%;
}
</style>